import React, { ChangeEvent, KeyboardEvent, useState } from 'react'
import { Classes } from '@blueprintjs/core';

type EnterCallback = () => void;

type FilterStringInputProps = {
  defaultFilledValue: string;
  onEnter: EnterCallback;
  onChange: any
}

const FilterStringInput = ({ defaultFilledValue, onEnter, onChange }: FilterStringInputProps) => {

  const [filledValue, setFilledValue] = useState<string>(defaultFilledValue)

  const handleEnter = (event: KeyboardEvent) => {
    if (event.key === 'Enter') {
      onEnter();
    }
  };

  const handleFilledValue = (event: ChangeEvent<HTMLInputElement>) => {
    setFilledValue(event.target.value)
    onChange(event.target.value)
  }

  return (
    <input
      autoFocus
      type="text"
      className={`${Classes.INPUT} custom-radio-button__input`}
      value={filledValue}
      onChange={handleFilledValue}
      onKeyDown={handleEnter}
    />
  )

}

export default FilterStringInput
